export const BIN_STATUS = {
    BIN_WITH_NO_BAG: "BIN_WITH_NO_BAG",
    BIN_WITH_ATTACHED_BAG: "BIN_WITH_ATTACHED_BAG",
    BIN_WITH_PS_BAG: "BIN_WITH_PS_BAG"
}